export const errorMessage = Object.freeze({
	DIRECT_TUNNEL_DISABLED: "Please contact the administrator to enable the direct tunnel.",
	DEVICE_NOT_FOUND: "Device does not exist. Please check that device has been registered correctly.",
	BAD_REQUEST: "Add Subnet Mapping failed. Please make sure that the subnet is correct.",
	ADD_SUBNET_MAPPING_PEER_NOT_FOUND: "Add Subnet Mapping failed, please make sure that the device is setup for direct tunnel.",
	SERVICE_STATUS_PEER_NOT_FOUND: "Please try to update the device firmware.",
	ALREADY_EXIST: "Subnet Mapping already exist.",
	NOT_ALLOWED_REMOVE: "Remove Subnet Mapping failed.",
	UNKNOWN_ERROR: "Unknown error, please contact the administrator.",
	ROUTE_NOT_FOUND: "Subnet Mapping not found. Will auto refresh the page."
})
